import {
  requestType,
  succeedType,
  failedType,
  VERIFY_ONBOARD_TOKEN,
  CREATE_USER_ACCOUNT,
  ACCOUNT_ALREADY_CREATED,
} from "./../actions/actionTypes";

const initState = {
  user: {},
  application: {},
  policy: {},
  creating_user: false,
  account_already_created: false,
};

export const onboardingReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(VERIFY_ONBOARD_TOKEN):
    case failedType(VERIFY_ONBOARD_TOKEN):
      return {
        ...state,
      };
    case succeedType(VERIFY_ONBOARD_TOKEN):
      return {
        ...state,
        user: action.user,
        application: action.application,
        policy: action.policy,
        secret_question_enabled: action.secret_question_enabled,
        secret_questions: action.secret_questions,
      };
    case ACCOUNT_ALREADY_CREATED:
      return {
        ...state,
        account_already_created: true,
        user: action.user,
        application: action.application,
        policy: action.policy,
      };
    case requestType(CREATE_USER_ACCOUNT):
      return {
        ...state,
        creating_user: true,
      };
    case succeedType(CREATE_USER_ACCOUNT):
      return {
        ...state,
        creating_user: false,
        account_already_created: true,
      };
    case failedType(CREATE_USER_ACCOUNT):
      return {
        ...state,
        creating_user: false,
      };
    default:
      return state;
  }
};
